<template>
  <div>
    <v-btn
      icon
      small
      @click="open"
    >
      <v-icon size="20">$vuetify.icons.settings</v-icon>
    </v-btn>
    <v-dialog
      :value="columnsDialogVisibility"
      content-class="custom-dialog"
      max-width="970px"
      scrollable
      @click:outside="close"
    >
      <v-card>
        <v-card-title>
          <app-logo />
          <span>Gallery Layouts</span>
          <v-spacer />
          <v-btn
            color="grey darken-1"
            icon
            small
            @click="close"
          >
            <v-icon size="16">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-for="(column, index) in columns"
            class="column-item"
            :class="{ 'column-item-bordered': index !== columns.length - 1 }"
            :key="column.id"
          >
            <div class="column-item-top">
              <v-switch
                dense
                hide-details
                inset
                :disabled="column.id === 1 || checkMaxWidth(index + 1)"
                :input-value="column.filtersForUI.showColumn"
                :label="column.id.toString()"
                :ripple="false"
                @change="handleChange($event, column.id)"
              />
              <v-btn
                small
                text
                :disabled="checkMaxWidth(index + 1)"
                @click="clear(column.id)"
              >
                Clear
              </v-btn>
            </div>
            <template v-for="(value, filter) in column.filtersForServer">
              <div
                v-if="showFilterLine(value, filter)"
                class="filter-item"
                :key="filter"
              >
                <v-chip
                  v-for="tag in value"
                  :disabled="!column.filtersForUI.showColumn"
                  :key="tag"
                  color="var(--v-grey-lighten-2)"
                  outlined
                  text-color="var(--v-secondary-base)"
                >
                  {{ tag }}
                </v-chip>
              </div>
            </template>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            outlined
            @click="close"
          >
            Close
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { CARS_COUNT } from '@/constants'
import AppLogo from '@/components/layout/AppLogo'

const MIN_COLUMN_WIDTH = 300

export default {
  name: 'GalleryColumnsDialog',
  components: {
    AppLogo,
  },
  computed: {
    ...mapGetters({
      columns: 'race/columns',
      columnsDialogVisibility: 'race/columnsDialogVisibility',
    }),
    raceId() {
      return this.$route.params.raceId
    },
  },
  methods: {
    ...mapActions({
      clearFiltersForServer: 'race/clearFiltersForServer',
      updateColumnVisibility: 'race/updateColumnVisibility',
      updateColumnsDialogVisibility: 'race/updateColumnsDialogVisibility',
    }),
    checkMaxWidth(columnIndex) {
      return columnIndex * MIN_COLUMN_WIDTH > window.innerWidth
    },
    clear(columnId) {
      this.clearFiltersForServer({
        columnId,
        raceId: this.raceId,
      })
    },
    close() {
      this.updateColumnsDialogVisibility(false)
    },
    handleChange(value, columnId) {
      this.updateColumnVisibility({
        columnId,
        raceId: this.raceId,
        value,
      })
    },
    open() {
      this.updateColumnsDialogVisibility(true)
    },
    showFilterLine(value, filter) {
      return value.length && filter !== CARS_COUNT
    },
  },
}
</script>

<style lang="scss" scoped>
.column-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.column-item-bordered {
  padding-right: 6px;
  border-right: 2px solid var(--v-grey-lighten-3);
}

.column-item-top {
  display: flex;
  justify-content: space-between;
  gap: 4px;
}

.filter-item {
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  row-gap: 4px;
}

::v-deep {
  .custom-dialog {
    box-shadow: var(--v-shadow-1);
  }

  .v-card__title {
    gap: 12px;
    padding: 6px 12px!important;
    background: var(--v-grey-lighten-5);
    box-shadow: inset 0px -1px 0px var(--v-grey-lighten-3);
    font-size: 16px!important;
    line-height: 24px;
  }

  .v-card__text {
    min-height: 200px;
    display: flex;
    gap: 6px;
    padding: 16px 12px!important;
  }

  .v-card__actions {
    border-top: 1px solid var(--v-grey-lighten-3);
    background: var(--v-grey-lighten-5);
    padding: 12px!important;
  }

  .v-input--switch {
    margin-top: 0;

    .v-input--selection-controls__input {
      height: 16px;
      width: 32px;
    }

    .v-input--switch__track {
      height: inherit!important;
      width: inherit!important;
      left: 0!important;
      top: 0!important;
    }

    .v-input--switch__thumb {
      width: 12px;
      height: 12px;
      translate: 2px 4px;

      &.primary--text {
        translate: -2px 4px;
      }
    }

    label {
      color: var(--v-secondary-base);
    }
  }
}
</style>
